import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Box, Button, Typography } from '@material-ui/core';
import { ROUTES } from '../../router/routes';
import ErrorTemplate from '../ErrorTemplate/ErrorTemplate';
import './../Error.scss';

const NotFound = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <ErrorTemplate>
      <Typography className="info__primary" variant="h1">
        {t('error.404.title')}
      </Typography>
      <Typography className="info__secondary" variant="h2">
        {t('error.404.content')}
      </Typography>
      <Box className="info__bnt">
        <Button
          className="bnt"
          variant="contained"
          size="large"
          onClick={() => {
            history.push(ROUTES.DASHBOARD);
          }}
        >
          {t('dashboard.home_page')}
        </Button>
      </Box>
    </ErrorTemplate>
  );
};

export default NotFound;
